import React from "react";

/**
 *
 * @param headers List of column headers.
 * @param data Can be a list or dictionary.
 * @param body Custom table body. Should not provide data if using body.
 * @returns Display Table
 */
const DisplayTable = ({
  headers,
  data,
  body,
  interact,
  customHeader,
  onClick,
  noData,
}) => {
  return (
    <div className="table-wrapper">
      <table className={`displayTable ${interact && "interactive-table"}`}>
        <thead>
          {customHeader ? (
            customHeader
          ) : (
            <tr className="head-row">
              {headers.map((element, index) => {
                return <th key={index + "headerEntry"}>{element}</th>;
              })}
            </tr>
          )}
        </thead>
        <tbody>
          {data
            ? typeof data === "object"
              ? Object.keys(data).map((elementKey, index) => {
                  return (
                    <tr
                      key={index + "dataEntry"}
                      onClick={() => {
                        if (interact) {
                          onClick(elementKey);
                        }
                      }}
                    >
                      {Object.keys(data[elementKey]).map((key, i) => (
                        <td key={"data" + i}>
                          <div>{data[elementKey][key]}</div>
                        </td>
                      ))}
                    </tr>
                  );
                })
              : data.map((element, index) => {
                  return (
                    <tr
                      key={index + "dataEntry"}
                      onClick={() => {
                        if (interact) {
                          onClick(index);
                        }
                      }}
                    >
                      {Object.keys(element).map((key, i) => (
                        <td key={"data" + i}>
                          <div>{element[key]}</div>
                        </td>
                      ))}
                    </tr>
                  );
                })
            : body}
        </tbody>
      </table>
      {noData && (
        <div className="no-data">
          <p>No data yet</p>
        </div>
      )}
    </div>
  );
};

export default DisplayTable;
